import { IonContent } from '@ionic/react';
import React from 'react';

import { PaymentModal } from '@/modals/Payment';
import { PaywallGuaranteePeriod } from '@/pages/Paywall/sections/GuaranteePeriod';

import { SectionPaymentMethodSelection } from '../../sections/PaymentMethodSelection';

import { PaywallV5Styles } from './FastPayTabsRoleplay.styles.ts';
import { SectionMainImage } from './sections/MainImage';
import { SectionSelectPlan } from './sections/SelectPlan';

const FastPayTabsRoleplay: React.FC = () => {
  return (
    <PaywallV5Styles>
      <IonContent>
        <SectionMainImage />

        <SectionSelectPlan />

        <SectionPaymentMethodSelection theme={'dark-forest'} />

        <PaywallGuaranteePeriod theme={'dark-forest'} />
      </IonContent>
      <PaymentModal />
    </PaywallV5Styles>
  );
};

export default FastPayTabsRoleplay;
